import { useAppSelector } from '../../redux/hooks';

function useTimezone() {
  const authData = useAppSelector((state) => state.auth);

  const timezone =
    authData?.constants?.timezone ||
    Intl.DateTimeFormat().resolvedOptions().timeZone;

  return timezone;
}

export default useTimezone;
